import { PublicClientApplication } from '@azure/msal-browser';

let msalInstance = null;
let cachedInstanceKey = null;

export const getMsalPopupRedirectUri = () => `${window.location.origin}/redirect.html`;

export const getMsalInstance = (tenantInfo) => {
  const clientId = tenantInfo?.microsoft_client_id;
  const tenantId = tenantInfo?.tenant_id;

  if (!clientId || !tenantId) {
    return null;
  }

  const instanceKey = `${clientId}:${tenantId}`;
  if (!msalInstance || cachedInstanceKey !== instanceKey) {
    cachedInstanceKey = instanceKey;
    msalInstance = new PublicClientApplication({
      auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}/`,
        redirectUri: getMsalPopupRedirectUri(),
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true,
      },
    });
  }

  return msalInstance;
};

export const resetMsalInstanceCache = () => {
  msalInstance = null;
  cachedInstanceKey = null;
};
